// A failed delivery sync is never shown to a teacher — but silence makes it
// impossible to support. This keeps the last few failures, plus a snapshot of
// what the sync loop can currently see, and hands both over only when someone
// deliberately calls window.__deliverySync() from a developer console.
//
// Reasons and state only: no lesson content, teacher notes, learner data or
// tokens ever go in here.

import { problemOf } from "./problems";

const LIMIT = 10;
const failures = [];
let probe = null;

const describe = (error) => ({
  problem: problemOf(error),
  status: error?.response?.status ?? null,
  code: error?.errors?.[0]?.extensions?.code ?? null,
  message: error?.errors?.[0]?.message ?? error?.message ?? String(error),
});

export const recordFailure = (lessonId, error) => {
  const entry = { at: new Date().toISOString(), lessonId, ...describe(error) };
  failures.unshift(entry);
  failures.length = Math.min(failures.length, LIMIT);
  return entry;
};

export const recentFailures = () => [...failures];

// An empty failure list means nothing failed — not that anything was tried.
// The snapshot is what tells those two apart.
export const setProbe = (snapshot) => {
  probe = snapshot;
};

export const report = () => ({
  failures: recentFailures(),
  ...(probe ? probe() : { note: "no signed-in teacher" }),
});

if (typeof window !== "undefined") {
  window.__deliverySync = report;
}
